export default __webpack_public_path__ + "static/media/radio-checked.2033e5c1.svg";